import { render, staticRenderFns } from "./BaseCurrency.vue?vue&type=template&id=005158ce&scoped=true&lang=pug&"
import script from "./BaseCurrency.vue?vue&type=script&lang=ts&"
export * from "./BaseCurrency.vue?vue&type=script&lang=ts&"
import style0 from "./BaseCurrency.vue?vue&type=style&index=0&id=005158ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005158ce",
  null
  
)

export default component.exports